import { bookingQueryOptions } from '@/hooks/queries/booking.queries';
import { useQuery } from '@tanstack/react-query';

export function useBookingAvailability(
  companyId?: string,
  serviceIds?: string[],
  professionalId?: string,
  cursor?: string | null,
  enabled = true,
) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(
    bookingQueryOptions.availability(companyId, serviceIds, professionalId, cursor, enabled),
  );

  return {
    availability: data,
    isError,
    isFetching,
    isLoading,
    refetch,
  };
}
